const MAX_FILE_NAME_SIZE = 30;
const FILE_EXTENSION_REGEX = /\.[^.]*?$/g;

const getFileExtension = (fileName: string): string => {
  const matches = fileName.match(FILE_EXTENSION_REGEX);
  return matches === null ? '' : matches[0];
};
export const truncateFileNameIfNeeded = (fileName: string): string => {
  if (fileName.length <= MAX_FILE_NAME_SIZE) {
    return fileName;
  }

  const fileExtension = getFileExtension(fileName);
  return `${fileName.substring(
    0,
    MAX_FILE_NAME_SIZE - fileExtension.length - 1
  )}…${fileExtension}`;
};
